"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledMobileMarker = exports.StyledNavigationItem = exports.StyledNavigation = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../../general");
const hoverActiveStyles = (0, styled_components_1.css) `
  background-color: ${theme_1.grayScale[100]};

  & p {
    color: ${theme_1.primary.light};
  }
`;
exports.StyledNavigation = (0, styled_components_1.default)(general_1.Paper) `
  ${({ expanded }) => (0, styled_components_1.css) `
    position: fixed;
    top: 0;
    left: 0;
    width: ${expanded ? '208px' : '80px'};
    height: 100vh;
    max-height: 100vh;
    z-index: 1000;
    transition: width 0.3s ease-in-out;
    background-color: ${theme_1.palette.grayScale[50]};
    padding: ${theme_1.spacings.s3};

    button[aria-label='toggle-navigation'] {
      align-self: flex-start;
      margin-top: 1rem;
    }

    p {
      ${expanded
    ? (0, styled_components_1.css) `
            transition: all 1.2s ease-in-out;
            width: unset;
            height: unset;
            opacity: 1;
            visibility: visible;
          `
    : (0, styled_components_1.css) `
            transition: all 0s ease-in-out;
            width: 0;
            height: 0;
            opacity: 0;
            visibility: hidden;
          `};
    }
  `}

  @media (max-width: 883px) {
    width: 100vw;
    height: 109px;
    max-height: 109px;
    bottom: 0;
    top: unset;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
    flex-wrap: nowrap;
  }
`;
exports.StyledNavigationItem = (0, styled_components_1.default)(general_1.Paper) `
  ${({ isActive }) => (0, styled_components_1.css) `
    cursor: pointer;
    width: 100%;
    height: 60px;
    transition: all 0.3s ease-in-out;
    flex-direction: row;
    padding: ${(0, utils_1.pxToRem)(15)};
    background-color: transparent;
    flex-wrap: nowrap;

    & p {
      color: ${theme_1.grayScale[600]};
      word-wrap: break-word;
    }
    & svg {
      flex-shrink: 0;
    }
    &:hover {
      ${hoverActiveStyles}
    }
    ${isActive && hoverActiveStyles}
  `}

  @media (max-width: 883px) {
    width: 48px;
    height: 48px;
    align-items: center;
    justify-content: center;
    padding: 0;
  }
  @media (max-width: 360px) {
    width: 40px;
    height: 40px;
  }
`;
exports.StyledMobileMarker = styled_components_1.default.div `
  width: 135px;
  height: 5px;
  background-color: ${theme_1.grayScale[900]};
  border-radius: 8px;
`;
//# sourceMappingURL=styles.js.map